const Error = (message) => {
  return `<li class="location-search__error">${message}</li>`;
};

export default Error;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/locationSearch/error.js